import { baseApi } from 'core/api';

const state = () => ({
    _items: null,
    _pagination: null,
    _parameters: {
        page: 1,
        sortBy: ['disabled', 'created_at'],
        sortOrder: 'desc',
        search: null,
        length: 10,
    },
    _editing: null,
    _deleting: null,
});

const getters = {
    cannedMessages: (state) => state._items,
    cannedMessagesParameters: (state) => state._parameters,
    cannedMessagesPagination: (state) => state._pagination,
    cannedMessagesEditing: (state) => state._editing,
    cannedMessagesDeleting: (state) => state._deleting,
};

const actions = {
    cannedMessagesLoad(retry) {
        if (retry === true) {
            this._setCannedMessagesRetryLoading();
        }

        return baseApi
            .get('core/canned-messages', { params: this._parameters })
            .then((response) => {
                this._setCannedMessagesLoaded(response.data);
                return response;
            })
            .catch(() => {
                this._setCannedMessagesErrorLoading();
            });
    },

    cannedMessageLoad(id) {
        return baseApi.get(`core/canned-messages/${id}`).then((response) => {
            return response.data;
        });
    },

    async cannedMessagesUpdatePage(page) {
        this._setCannedMessagesUpdatePage(page);

        await this.cannedMessagesLoad();
    },

    async cannedMessagesUpdateSearch(query) {
        this._setCannedMessagesUpdateSearch(query);

        await this.cannedMessagesLoad();
    },

    async cannedMessagesClearSearch() {
        this._setCannedMessagesSearchCleared();

        await this.cannedMessagesLoad();
    },

    updateCannedMessages(form) {
        return form.post('core/canned-messages').then((response) => {
            this._setCannedMessageCreated(response.data);

            return response.data;
        });
    },

    cannedMessagesUpdate({ id, form }) {
        return form.put(`core/canned-messages/${id}`).then((response) => {
            this._setCannedMessageUpdated(response.data);

            return response;
        });
    },

    async cannedMessagesUpdateSort(sort) {
        this._setCannedMessagesUpdateSort(sort);

        await this.cannedMessagesLoad();
    },

    deleteCannedMessagesById({ id, form }) {
        return form.delete(`core/canned-messages/${id}`).then((response) => {
            this._setCannedMessageDeleted(id);

            return response;
        });
    },

    cannedMessagesBulkDelete(form) {
        return form.delete('core/canned-messages').then((response) => {
            this._setCannedMessagesBulkDeleted(form.ids);

            return response;
        });
    },

    cannedMessageCreated(cannedMessage) {
        this._setCannedMessageCreated(cannedMessage);
    },

    cannedMessageUpdated(cannedMessage) {
        this._setCannedMessageUpdated(cannedMessage);
    },

    cannedMessageDeleted({ id }) {
        this._setCannedMessageDeleted(id);
    },

    cannedMessagesBulkDeleted(ids) {
        this._setCannedMessagesBulkDeleted(ids);
    },

    // Private methods
    _setCannedMessageCreated(data) {
        if (this._items === null) {
            return;
        }
        this._items.unshift(data);
        ++this.total;
    },

    _setCannedMessageUpdated(data) {
        if (this._items === null) {
            return;
        }
        this._items = this._items.map((o) => {
            if (o.id === data.id) {
                return data;
            } else {
                return o;
            }
        });
    },

    _setCannedMessageDeleted(id) {
        if (!this._items) return;
        this._items = this._items.filter((o) => o.id !== id);
        --this.total;
    },

    _setCannedMessagesBulkDeleted(ids) {
        if (!this._items) return;
        this._items = this._items.filter((o) => {
            return ids.indexOf(o.id) === -1;
        });
        this.total = this.total - ids.length;
    },

    _setCannedMessagesLoaded(data) {
        this._items = data.data;
        this._pagination = {
            current_page: data.current_page,
            from: data.from,
            last_page: data.last_page,
            per_page: data.per_page,
            to: data.to,
            total: data.total,
        };
    },

    _setCannedMessagesRetryLoading() {
        this._items = null;
        this._parameters = {
            page: 1,
            sortBy: ['disabled', 'created_at'],
            sortOrder: 'desc',
            search: null,
            length: 10,
        };
    },

    _setCannedMessagesErrorLoading() {
        this._items = false;
        this._parameters = {
            page: 1,
            sortBy: ['disabled', 'created_at'],
            sortOrder: 'desc',
            search: null,
            length: 10,
        };
    },

    _setCannedMessagesSearchCleared() {
        this._parameters = {
            page: 1,
            sortBy: ['disabled', 'created_at'],
            sortOrder: 'desc',
            search: null,
            length: 10,
        };
    },

    _setCannedMessagesUpdatePage(data) {
        this._parameters.page = data;
    },

    _setCannedMessagesUpdateSearch(data) {
        this._parameters.page = 1;
        this._parameters.search = data;
    },

    _setCannedMessagesUpdateSort(data) {
        this._parameters.sortBy = ['disabled', data.sortBy];
        this._parameters.sortOrder = data.sortOrder;
    },
};

export default {
    state,
    getters,
    actions,
};
